// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconButton_icon__3VJM2","button":"IconButton_button__iRO-I","rotate":"IconButton_rotate__3cOSz","slideIn":"IconButton_slideIn__qGrcP","fadeIn":"IconButton_fadeIn__25u5w"};